import script from "./RgpdMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./RgpdMessage.vue?vue&type=script&setup=true&lang=js"

import "./RgpdMessage.vue?vue&type=style&index=0&id=20aa5edc&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20aa5edc"]])

export default __exports__